import { experienceAvailabilitiesService } from '@/services/experienceAvailabilities.service.js';

const state = {
  getExperienceAvailabilitiesOutput: null,
  getExperienceAvailabilityByIdOutput: null,
  createExperienceAvailabilityOutput: null,
  updateExperienceAvailabilityOutput: null,
  deleteExperienceAvailabilityByIdOutput: null,
  archiveExperienceAvailabilityByIdOutput: null,
  unarchiveExperienceAvailabilityByIdOutput: null
};

const mutations = {
  setGetExperienceAvailabilitiesOutput(state, payload) {
    state.getExperienceAvailabilitiesOutput = payload;
  },
  setGetExperienceAvailabilityByIdOutput(state, payload) {
    state.getExperienceAvailabilityByIdOutput = payload;
  },
  setCreateExperienceAvailabilityOutput(state, payload) {
    state.createExperienceAvailabilityOutput = payload;
  },
  setUpdateExperienceAvailabilityOutput(state, payload) {
    state.updateExperienceAvailabilityOutput = payload;
  },
  setDeleteExperienceAvailabilityByIdOutput(state, payload) {
    state.deleteExperienceAvailabilityByIdOutput = payload;
  },
  setArchiveExperienceAvailabilityByIdOutput(state, payload) {
    state.archiveExperienceAvailabilityByIdOutput = payload;
  },
  setUnarchiveExperienceAvailabilityByIdOutput(state, payload) {
    state.unarchiveExperienceAvailabilityByIdOutput = payload;
  }
};

const actions = {
  async getExperienceAvailabilities({ commit }, input) {
    try {
      const response = await experienceAvailabilitiesService.getList(input);
      commit('setGetExperienceAvailabilitiesOutput', response);
      return response;
    } catch (error) {
      console.error('Error fetching experience availabilities list:', error);
      throw error;
    }
  },
  
  async getById({ commit }, id) {
    try {
      const response = await experienceAvailabilitiesService.getById(id);
      commit('setGetExperienceAvailabilityByIdOutput', response);
      return response;
    } catch (error) {
      console.error('Error fetching experience availability by id:', error);
      throw error;
    }
  },
  
  async create({ commit }, data) {
    try {
      const response = await experienceAvailabilitiesService.create(data);
      commit('setCreateExperienceAvailabilityOutput', response);
      return response;
    } catch (error) {
      console.error('Error creating experience availability:', error);
      throw error;
    }
  },
  
  async update({ commit }, data) {
    try {
      const response = await experienceAvailabilitiesService.update(data);
      commit('setUpdateExperienceAvailabilityOutput', response);
      return response;
    } catch (error) {
      console.error('Error updating experience availability:', error);
      throw error;
    }
  },
  
  async deleteExperienceAvailabilityById({ commit }, id) {
    try {
      const response = await experienceAvailabilitiesService.delete(id);
      commit('setDeleteExperienceAvailabilityByIdOutput', response);
      return response;
    } catch (error) {
      console.error('Error deleting experience availability:', error);
      throw error;
    }
  },
  
  async archiveExperienceAvailabilityById({ commit }, id) {
    try {
      const response = await experienceAvailabilitiesService.archive(id);
      commit('setArchiveExperienceAvailabilityByIdOutput', response);
      return response;
    } catch (error) {
      console.error('Error archiving experience availability:', error);
      throw error;
    }
  },
  
  async unarchiveExperienceAvailabilityById({ commit }, id) {
    try {
      const response = await experienceAvailabilitiesService.unarchive(id);
      commit('setUnarchiveExperienceAvailabilityByIdOutput', response);
      return response;
    } catch (error) {
      console.error('Error unarchiving experience availability:', error);
      throw error;
    }
  }
};

const getters = {
  experienceAvailabilities: state => state.getExperienceAvailabilitiesOutput?.data || [],
  experienceAvailability: state => state.getExperienceAvailabilityByIdOutput || null
};

export const experienceAvailabilities = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};

